import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "43.606",
  viewBox: "0 0 43.606 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M21.803 50C9.8 50 0 40.2 0 28.2c0-8.857 5.294-16.718 13.417-20.126l1.415 3.407C8.072 14.31 3.67 20.86 3.67 28.2c0 10.006 8.122 18.13 18.132 18.13s18.136-8.126 18.136-18.136c0-7.234-4.613-14.152-11.163-16.823l1.363-3.405c8.07 3.23 13.468 11.34 13.468 20.15 0 12.104-9.8 21.854-21.803 21.854zm1.834-50H19.97v20.02h3.667V0z"
  })]
});